module.exports = __webpack_public_path__ + "static/media/compliance.6089ebf5.svg";